import { CIA_ANALYSIS_STORAGE_PREFIX } from '../constants/cia';
import type { ICiaAnalysis } from '../types/cia';

const HTML_CONTENT_TYPE = 'text/html;charset=utf-8';

const getStorageKey = (analysisId: string): string =>
  `${CIA_ANALYSIS_STORAGE_PREFIX}${analysisId}`;

// O sessionStorage é copiado para a nova guia aberta via window.open,
// permitindo que a guia de análise leia o conteúdo gerado pela Cia.
const saveCiaAnalysis = (analysis: ICiaAnalysis): string => {
  const analysisId = crypto.randomUUID();

  sessionStorage.setItem(getStorageKey(analysisId), JSON.stringify(analysis));

  return analysisId;
};

const getCiaAnalysis = (analysisId: string): ICiaAnalysis | null => {
  const value = sessionStorage.getItem(getStorageKey(analysisId));

  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value) as ICiaAnalysis;
  } catch {
    return null;
  }
};

const getCiaAnalysisTitle = (analysis: ICiaAnalysis): string => {
  const doc = new DOMParser().parseFromString(analysis.content, 'text/html');
  const heading = doc.querySelector('h1')?.textContent?.replace(/\s+/g, ' ');

  return heading?.trim() || analysis.title;
};

const buildCiaAnalysisFileName = (title?: string): string => {
  const date = new Date().toISOString().replace(/[-:T]/g, '').slice(0, 14);
  const name = (title || 'Analise_Cia')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '_');

  return `${name || 'Analise_Cia'}_${date}.html`;
};

const createCiaAnalysisFile = (analysis: ICiaAnalysis): File =>
  new File([analysis.content], buildCiaAnalysisFileName(analysis.title), {
    type: HTML_CONTENT_TYPE,
  });

const downloadCiaAnalysis = (analysis: ICiaAnalysis): void => {
  const url = URL.createObjectURL(createCiaAnalysisFile(analysis));
  const link = document.createElement('a');

  link.href = url;
  link.download = buildCiaAnalysisFileName(analysis.title);
  link.click();

  URL.revokeObjectURL(url);
};

export {
  saveCiaAnalysis,
  getCiaAnalysis,
  getCiaAnalysisTitle,
  createCiaAnalysisFile,
  downloadCiaAnalysis,
};
